import styled from "styled-components";
import IcNotificationIconDelete from "../../images/ic_icon_dot_notification_delete.svg";

export const DivNotificationTabs = styled.div`
  ${(props) => `
        font-family: ${props.theme.fontFamilies.primaryFont};
    `}
  .notification-tab-class-div .p-tabview-nav-container .p-tabview-nav-content .p-tabview-nav {
    display: flex;
    justify-content: space-between;
  }

  .notification-tab-class-div
    .p-tabview-nav-container
    .p-tabview-nav-content
    .p-tabview-nav
    li.p-highlight
    .p-tabview-nav-link {
    background: #ffffff;
    border-color: #0068f3;
    color: #0068f3;
  }

  .notification-tab-class-div
    .p-tabview-nav-container
    .p-tabview-nav-content
    .p-tabview-nav
    li
    .p-tabview-nav-link:not(.p-disabled):focus {
    box-shadow: inset 0 0 0 0.2rem #ffffff;
    outline-offset: 0;
    outline: 0 none;
  }

  .notification-tab-class-div
    .p-tabview-nav-container
    .p-tabview-nav-content
    .p-tabview-nav
    li
    .p-tabview-nav-link {
    border-width: 0px 0px 4px 0px;
  }

  .image-icon {
    height: 2.5rem;
    width: 3rem;
  }

  .notification-tab-class-div
    .p-tabview-nav-container
    .p-tabview-nav-content
    .p-tabview-nav
    li
    .p-tabview-nav-link {
    color: #002e6c;
  }
`;

export const NotificationDiv = styled.div<any>`
  ${(props) => `
      color: ${props.color ? props.color : "#2E353D"};
      font-family: ${props.theme.fontFamilies.primaryFont};
      font-size:${props.fontSize ? props.fontSize : "1.3rem"};
      font-weight:${props.fontWeight ? props.fontWeight : 500};
      margin-bottom: ${props.marginBottom ? props.marginBottom : "0rem"};
      margin-left: ${props.marginLeft ? props.marginLeft : "0rem"};
      margin-top:${props.marginTop ? props.marginTop : "0rem"};
      padding-bottom: ${props.paddingBottom ? props.paddingBottom : "0rem"};
      padding-left: ${props.paddingLeft ? props.paddingLeft : "0rem"};
      padding-top:${props.paddingTop ? props.paddingTop : "0rem"};
 `}
  font-style: normal;
`;

export const IconNotificationDiv = styled.div<any>`
  ${(props: any) => `
      margin-right: ${props.marginRight ? props.marginRight : "0rem"};
      margin-top:${props.marginTop ? props.marginTop : "0rem"};
 `}
  .icon-size {
    cursor: not-allowed;
    height: 4rem;
    width: 4rem;
  }
`;

export const DivContentNotification = styled.div`
  &:hover {
    background: #e7e7ea;
    border-radius: 8px;
    .img-dots {
      background-repeat: no-repeat;
      background-size: 100% 100% !important;
      background: url(${IcNotificationIconDelete});
    }
  }
`;
export const DivNotificationBell = styled.div<any>`
  align-items: center;
  display: flex;
  justify-content: center;
  ${(props: any) => `
        font-family: ${props.theme.fontFamilies.primaryFont};
        font-size:${props.fontSize ? props.fontSize : "1.4rem"};
        font-weight:${props.fontWeight ? props.fontWeight : 500};
        height:${props.height ? props.height : "80vh"};
        margin-bottom: ${props.marginBottom ? props.marginBottom : "0rem"};
        margin-left: ${props.marginLeft ? props.marginLeft : "0rem"};
        margin-top:${props.marginTop ? props.marginTop : "0rem"};

        @media (max-height: 750px) {
          height: 70vh;
        }
        @media (max-height: 420px) {
          height: 60vh;
        }
    `}
`;
export const DivNotificationBellLabel = styled.div<any>`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${(props: any) => `
        font-family: ${props.theme.fontFamilies.primaryFont};
        font-size:${props.fontSize ? props.fontSize : "1.4rem"};
        font-weight:${props.fontWeight ? props.fontWeight : 500};
        margin-bottom: ${props.marginBottom ? props.marginBottom : "0rem"};
        margin-left: ${props.marginLeft ? props.marginLeft : "0rem"};
        margin-top:${props.marginTop ? props.marginTop : "0rem"};
    `}
  .img-bell {
    height: 16rem;
    width: 13rem;
  }
`;

export const TitleNotification = styled.div`
  color: #002e6c;
  font-size: 1.8rem;
  font-weight: 600;
  margin-left: 1.1rem;
`;
